import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueAgile from "vue-agile";
import VModal from "vue-js-modal";
import data from "./data.js";
import Header from "./components/Header.vue";

Vue.component("Header", Header);
Vue.config.productionTip = false;

Vue.mixin({
    data: function() {
        return {
            projectList: data
        };
    }
});

Vue.use(VModal, { dialog: true });
Vue.use(VueAgile);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
